async function delay(milliseconds: number) {
  if (milliseconds <= 0) return;

  await new Promise<void>((resolve) => {
    setTimeout(() => resolve(), milliseconds);
  });
}

//

export function delaySync(milliseconds: number, callback: () => void) {
  delay(milliseconds)
    .then(callback)
    .catch((e) => console.error(e));
}

//

export default delay;
